import {useEffect, useState} from "react";
import {Redirect} from "react-router-dom";
import {getApplicationState, setApplicationState} from "../../services/common";
import {genRandomString} from "@okta/okta-auth-js";
import {getAppleAuthorizeUrl} from "../../services/api/socialIdentityApi";

const AppleRedirect = () => {
	const [completed, setCompleted] = useState(false);

	useEffect(() => {
		(async () => {
			try {
				const appState = getApplicationState();
				if(!('apple' in appState)) {
					appState.apple = {};
				}

				appState.apple.state = genRandomString(32);

				setApplicationState(appState);

				const response = await getAppleAuthorizeUrl(appState.apple.state);

				if (!response?.data?.data) {
					setCompleted(true);
					return;
				}

				window.location.href = response.data.data;
			}
			catch(_) {
				setCompleted(true);
			}
		})();
	}, []);

	if(completed) {
		return (<Redirect to={'/'} />);
	}

	return (<></>);
}

export default AppleRedirect;
